import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaChevronRight } from "react-icons/fa";

const DealsSection = () => {
  return (
    <div className="container py-5">
      {/* Headings */}
      <div className="row mb-4">
        <div className="col-md-6 d-flex justify-content-between align-items-center">
          <h3 className="fw-bold mb-0">Grand Global Brand </h3>
          <button
            style={{
              backgroundColor: "#ff7043",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <div style={{ fontSize: "24px" }}>
  <FaChevronRight color="black" /> Test Icon
</div>

          </button>
        </div>

        <div className="col-md-6 d-flex justify-content-between align-items-center">
          <h3 className="fw-bold mb-0">Fashion's Top Deals</h3>
          <button
            style={{
              backgroundColor: "#ff7043",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <div style={{ fontSize: "24px" }}>
  <FaChevronRight color="black" /> Test Icon
</div>

          </button>
        </div>
      </div>

      {/* Top Cards Section */}
      <div className="row mb-5">
        <div className="col-md-3">
          <div className="card shadow-sm border-0">
            <img
              src="https://via.placeholder.com/250x200"
              className="card-img-top"
              alt="Sofa Beds"
            />
            <div className="card-body text-center">
              <p className="mb-1">Sofa Beds</p>
              <p className="fw-bold mb-0">Min. 50% Off</p>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm border-0">
            <img
              src="https://via.placeholder.com/250x200"
              className="card-img-top"
              alt="Shoe Rack"
            />
            <div className="card-body text-center">
              <p className="mb-1">Shoe Rack</p>
              <p className="fw-bold mb-0">Min. 50% Off</p>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm border-0">
            <img
              src="https://via.placeholder.com/250x200"
              className="card-img-top"
              alt="Men's Sports Shoes"
            />
            <div className="card-body text-center">
              <p className="mb-1">Men's Sports Shoes</p>
              <p className="fw-bold mb-0">Min. 70% Off</p>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm border-0">
            <img
              src="https://via.placeholder.com/250x200"
              className="card-img-top"
              alt="Men's Casual Shoes"
            />
            <div className="card-body text-center">
              <p className="mb-1">Men's Casual Shoes</p>
              <p className="fw-bold mb-0">Min. 70% Off</p>
            </div>
          </div>
        </div>
      </div>

      {/* Orange Cards Section */}
      <div className="row g-3">
        {[
          { title: "Personal care", heading: "Dove & more" },
          { title: "Top brands", heading: "Pressure washer" },
          { title: "Fun essentials", heading: "Toys & stationery" },
          { title: "Healthy snacks", heading: "Dry Fruits" },
        ].map((item, index) => (
          <div className="col-md-3" key={index}>
            <div
              className="card text-white border-0"
              style={{ backgroundColor: "#ff7043" }}
            >
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <p className="mb-1 small">{item.title}</p>
                  <h5 className="fw-bold">{item.heading}</h5>
                  <button className="btn btn-light mt-2">Shop Now</button>
                </div>
                <img
                  src="https://via.placeholder.com/80"
                  alt="Product"
                  className="img-fluid ms-2"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DealsSection;
